<template>
  <div class="transfer-file-index">
    <h2>Upload Files</h2>
    <file-transfer-upload v-model="your_email" />

    <div class="transfer-form-container">
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        class="transfer-form"
      >
        <el-form-item
          label="Email to"
          prop="email_to"
          :rules="email_rules"
        >
          <el-input v-model="form.email_to" />
        </el-form-item>

        <el-form-item
          label="Your Email"
          prop="your_email"
        >
          <el-input v-model="your_email" />
        </el-form-item>

        <el-form-item
          label="Title"
          prop="title"
          :rules="title_rules"
        >
          <el-input v-model="form.title" />
        </el-form-item>

        <el-form-item
          label="Message"
          prop="message"
        >
          <el-input
            v-model="form.message"
            type="textarea"
            :rows="8"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            @click="send_email"
          >
            Continue
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import FileTransferUpload from './FileTransferUpload.vue';

export default {
  name: 'FileTransferForm',
  components: { FileTransferUpload },
  data() {
    return {
      your_email: '',
      form: {
        email_to: '',
        title: '',
        your_email: '',
        message: '',
      },
      email_rules: [
        { required: true, message: 'Please enter a valid email address', trigger: 'blur' },
        { type: 'email', message: 'Please enter a valid email address', trigger: ['blur', 'change'] },
      ],
      title_rules: [
        { required: true, message: 'Please enter the title', trigger: 'blur' },
      ]
    };
  },
  mounted() {
    this.set_default_input();
  },
  methods: {
    send_email() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

      if (!emailRegex.test(this.your_email)) {
        this.$message({
          message: 'Your email address is invalid.',
          type: 'error'
        });
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.your_email = this.your_email;
          this.$http.post('/api/file_transfers/send_email', { form: this.form }).then(response => {
            this.$message({
              message: response.data.message,
              type: 'success'
            });
            console.log('Form Data:', this.form);
            this.$refs.form.resetFields();
          }).catch(() => {
            this.$message({
              message: 'Failed to send email.',
              type: 'error'
            });
          });
        } else {
          console.log('Form validation failed!');
        }
      });
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-select__input, .el-input__inner, .el-textarea__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    },
  },
};
</script>

<style>
.transfer-form-container .el-form-item__error {
  padding: 0px !important;
  z-index: 5;
}
</style>

<style scoped>
.transfer-form-container {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.transfer-form {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.el-form-item {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
  margin-top: 20px;
}

.el-input__inner, .el-textarea__inner {
  border-radius: 8px;
  padding: 10px;
}

.el-form-item label {
  font-weight: bold;
}

.el-form-item .el-input,
.el-form-item .el-textarea {
  margin-top: 10px;
}


.transfer-file-index h2 {
  text-align: center;
  margin-bottom: 30px;
}
</style>
